import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { useContext } from 'react';
import { Box, Flex } from '@chakra-ui/react';
import { RFNodeIcon, RFSvg } from '../../base';
import { useNodeTemplate } from '../../../hooks';
import { RFConfigContext } from '../../../contexts';
import { FRACTIONATOR_CONFIG } from './RFFractionatorNode.config';
/**
 * Component renders "fractionator" type of node of ReactFlow.
 * @param props : props come from ReactFlow.
 * See RF_NODE_TYPES.
 */
const RFFractionatorNodeFC = ({ id, data, type, isConnectable = true, selected }) => {
    const { isInspector } = useContext(RFConfigContext) ?? {};
    const { isValidTemplate, renderPorts, renderError } = useNodeTemplate({
        id,
        selected,
        templateCode: data.templateCode,
        config: FRACTIONATOR_CONFIG
    });
    return isValidTemplate ? (_jsxs(_Fragment, { children: [_jsxs(Flex, { "data-templateid": data.templateCode, gap: "4px", flexDirection: "column", children: [_jsx(RFNodeIcon, { id: id, rfType: type, isSelected: selected, isInspector: isInspector, templateCode: data.templateCode ?? '', children: _jsx(RFSvg, { name: FRACTIONATOR_CONFIG.icon, width: 124, height: 255 }) }), _jsx(Box, { p: "0 8px", maxW: "140px", fontSize: "12px", lineHeight: "14px", fontWeight: 700, className: "cut-text", children: data.title })] }), renderPorts(isConnectable, isInspector)] })) : (_jsx(_Fragment, { children: renderError() }));
};
export const RFFractionatorNode = RFFractionatorNodeFC;
//# sourceMappingURL=RFFractionatorNode.js.map